const OPENID = 'openid';
const UUID = 'uuid';
const TOKEN = 'token';
const USER_ID = 'userId';
const USER_INFO = 'userInfo';
const USER_MOBILE = 'user_mobile';
const SELECTED_DEVICE_ID = 'selected_deviceid';
const LOGIN_TIME_STAMP = 'login_time_stamp'; // 登录的时间
const EXPIRED_TIME = 'expired_time'; //token过期时间

// 设备状态
const DEVICE_STATUS = {
	offline: 'offline',
	online: 'online',
};

// 播放列表类型
const PLAYLIST_TYPE = {
	view: 'view',
	subtitle: 'subtitle',
	audio: 'audio',
	html: 'html',
};

const titleMap = {
	nickname: '昵称',
	tel: '店铺电话',
	address: '店铺地址',
	shop: '店铺名',
};

const userField = {
	nickname: 'name',
	tel: 'telephone',
	address: 'address',
	shop: 'shop',
};
// 首页根据跳转
const homeRedirectMap = {
	devfee: '/devfee',
	register: '/register',
	update: '/appUpdate',
	activation: '/activation',
};

// 上传转码结果
const resolveResult = {
	warning: {
		text: '启动转码',
		color: '#f0ad4e',
	},
	success: {
		text: '解析成功',
		color: '#5cb85c',
	},
	fail: {
		text: '解析失败',
		color: '#d9534f',
	},
};
// 上传转码结果
const uploadResult = {
	success: {
		text: '上传成功',
		color: '#5cb85c',
	},
	fail: {
		text: '文件无法解析！',
		color: '#d9534f',
	},
	error: {
		text: '上传失败！',
		color: '#d9534f',
	}
};

export {
	OPENID,
	UUID,
	TOKEN,
	USER_INFO,
	USER_ID,
	USER_MOBILE,
	DEVICE_STATUS,
	PLAYLIST_TYPE,
	SELECTED_DEVICE_ID,
	LOGIN_TIME_STAMP,
	EXPIRED_TIME,
	titleMap,
	userField,
	homeRedirectMap,
	resolveResult,
	uploadResult,
};
